import { isNil } from "lodash";
import React from "react";
import SegmentedBarSegment from "./SegmentedBarSegment";
import SegmentedBarItem from "./SegmentedBarItem";
import * as colors from "../../helpers/constants/colors";
import "./SegmentedBar.css";

const BIN_COLORS = colors.segmentedBar.spectrum;

class SegmentedBar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            binRatios: [],
            positions: {}
        };
    }

    /*
     Component Lifecycle Methods
     */

    componentWillMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    componentDidMount() {
        this.updateDimensions();
    }

    componentWillReceiveProps() {
        this.updateDimensions();
    }

    /*
     Component Calculation Methods
     */
    updateDimensions = () => {
        return this.setState((state, props) => {
            if (!this._root) {
                return state;
            }

            const binRatios = this.calculateBinRatios(props);

            const rect = this._root.getBoundingClientRect();
            const rects = this.generateSegmentBoundRects(binRatios, rect);
            const positions = this.transitionItemsToPoints(rects, props);

            return { binRatios, positions };
        });
    };

    calculateBinRatios(props) {
        return props.bins.map(({ pageIds }) => {
            return 1 + (pageIds ? pageIds.length * 0.1 : 0);
        });
    }

    generateSegmentBoundRects(binRatios, bar) {
        const ratioAggregate = binRatios.reduce((sum, ratio) => sum + ratio);
        const base = bar.width / ratioAggregate;
        const rects = binRatios.reduce(
            (all, ratio) => {
                const width = all.base * ratio;
                all.segments.push({
                    left: all.widths,
                    mid: width * 0.5,
                    width: width
                });
                all.widths = all.widths + width;
                return all;
            },
            { widths: 0, base, segments: [] }
        );
        return rects.segments;
    }

    transitionItemsToPoints(rects, props) {
        const newPositions = props.bins.reduce((positions, bin, segment) => {
            if (bin.pageIds.length === 0) {
                return positions;
            }

            if (bin.pageIds.length === 1) {
                positions[`${segment}-${bin.pageIds[0]}`] =
                    rects[segment].left + rects[segment].mid;
                return positions;
            }

            /*
             May not be the most efficient way of solving the problem,
             but basically we needed to balance the items within a bin
             so that:
             1) They are evenly space and centered in the bin
             2) If there is a direct center, a pin should be on it
             3) If there is no direct center, all pins balance on
             either side of the direct center
             4) The baseline page must be (or at most
             one step away from) the direct center
             */
            const midpoint = bin.pageIds.length / 2;
            const belowMidpoint = bin.pageIds.slice(0, midpoint);
            const aboveMidpoint = bin.pageIds.slice(midpoint);

            const centerPageId =
                aboveMidpoint.length > belowMidpoint.length
                    ? aboveMidpoint.shift()
                    : belowMidpoint.length > aboveMidpoint.length
                        ? belowMidpoint.pop()
                        : null;

            const scaleFactor = 50;
            const pinWidth = 30;
            const actualScale =
                centerPageId === null ? scaleFactor / 2 : scaleFactor;
            if (centerPageId !== null) {
                positions[`${segment}-${centerPageId}`] =
                    rects[segment].left + rects[segment].mid;
            }

            belowMidpoint.forEach((pageId, index) => {
                let newPos =
                    rects[segment].left +
                    rects[segment].mid -
                    actualScale * (index + 1);
                if (newPos - pinWidth / 2 <= rects[segment].left) {
                    newPos = rects[segment].left + pinWidth / 2;
                }
                positions[`${segment}-${pageId}`] = newPos;
            });

            aboveMidpoint.forEach((pageId, index) => {
                let newPos =
                    rects[segment].left +
                    rects[segment].mid +
                    actualScale * (index + 1);
                const right = rects[segment].left + rects[segment].width;
                if (newPos + pinWidth / 2 >= right) {
                    newPos = right - pinWidth / 2;
                }
                positions[`${segment}-${pageId}`] = newPos;
            });

            return positions;
        }, {});

        return newPositions;
    }

    /*
     Component Render Methods
     */
    renderSegmentBinItems() {
        return this.props.bins.map(({ pageIds }, segment) => {
            if (isNil(pageIds) || pageIds.length === 0) {
                return null;
            }
            const pages = this.props.pages.filter(page =>
                pageIds.includes(page.id)
            );
            return pages.map(page => {
                const position =
                    this.state.positions[`${segment}-${page.id}`] || 0;
                return (
                    <SegmentedBarItem
                        position={position}
                        key={`segmented-bar-item(${segment}-${page.id})`}
                        page={page}
                        isWinner={page.isWinner}
                        isSelected={page.isSelected}
                    />
                );
            });
        });
    }

    renderBarSegments() {
        return this.props.bins.map((threshold, index) => (
            <SegmentedBarSegment
                key={`segment-${index}`}
                color={BIN_COLORS[index]}
                ratio={this.state.binRatios[index]}
                threshold={threshold}
            />
        ));
    }

    render() {
        return (
            <div className="SegmentedBarContainer">
                <section
                    className="SegmentedBar"
                    ref={element => {
                        this._root = element;
                    }}
                >
                    <div className="BarSegment_items">
                        {this.renderSegmentBinItems()}
                    </div>
                    <div className="BarSegments">
                        {this.renderBarSegments()}
                    </div>
                </section>
            </div>
        );
    }
}

export default SegmentedBar;



// WEBPACK FOOTER //
// ./src/components/SegmentedBar/SegmentedBar.js